import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { RouterOutlet, Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';

import { JwtService, WorkspaceStateService } from '@core/services';
import { MenuComponent } from '@ui/shared';

@Component({
    selector: 'app-main',
    standalone: true,
    templateUrl: './workspace-layout.component.html',
    styleUrls: ['./workspace-layout.component.scss'],
    imports: [
        CommonModule, 
        RouterOutlet,
        MatSidenavModule,
        MatToolbarModule,
        MatCardModule,
        MatIconModule,
        RouterModule,
        MatTooltipModule,
        MenuComponent,
    ],
})
export class WorkspaceLayoutComponent {

    //title = 'edl3a';
    
    private breakpointObserver = inject(BreakpointObserver);

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches),
            shareReplay()
        );

    constructor(
        private router: Router, 
        public ws: WorkspaceStateService) {

    }

    logout() {
        JwtService.clear();
        this.router.navigateByUrl('/login');
    }
}
